// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as ApertureCtx from "../ctx/ApertureCtx.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as UnitOverview from "./UnitOverview.bs.js";
import * as InContextOverview from "./InContextOverview.bs.js";

function InContextUnitOverview(Props) {
  var unitId = Props.unitId;
  var onClose = Props.onClose;
  var match = React.useState(function () {
        return null;
      });
  var setScrollRef = match[1];
  var aperture = ApertureCtx.useValue(undefined);
  var unitsT = Translation.useT(/* Units */1);
  var match$1 = React.useState(function () {
        return 0;
      });
  var starLevel = match$1[0];
  return React.createElement(InContextOverview.make, {
              header: React.createElement("div", {
                    className: "flex items-center"
                  }, React.createElement(UnitImage.make, {
                        unitId: unitId,
                        size: 32
                      }), React.createElement("div", {
                        className: "pl-2 font-medium text-xl"
                      }, unitsT(unitId))),
              onExpand: {
                TAG: /* Stats */0,
                _0: {
                  TAG: /* Unit */4,
                  unit: unitId,
                  starLevel: starLevel === 0 ? undefined : starLevel,
                  aperture: aperture
                }
              },
              children: React.createElement("div", {
                    className: "p-4 pt-16"
                  }, React.createElement(UnitOverview.make, {
                        inContext: true,
                        unitId: unitId,
                        starLevel: starLevel,
                        setStarLevel: match$1[1],
                        scrollRef: match[0],
                        key: unitId
                      })),
              onClose: onClose,
              setScrollRef: (function (ref) {
                  return Curry._1(setScrollRef, (function (param) {
                                return ref;
                              }));
                })
            });
}

var make = InContextUnitOverview;

export {
  make ,
  
}
/* react Not a pure module */
